"use client";
import { SECTION_TITLE } from "@shared/constants/typography";
import { Button } from "@ui/components/button";
import { ChevronRight } from "lucide-react";
import { useTranslations } from "next-intl";
import {
	type StandaloneImageEffect,
	imageEffectExamples,
} from "../config/image-effect-examples";
export function ImageEffectCta({ effect }: { effect: StandaloneImageEffect }) {
	const t = useTranslations(
		`${imageEffectExamples[effect].namespace}.examples.cta`,
	);
	const form = useTranslations("imageTransformation");
	return (
		<section className="py-12 sm:py-20">
			<div className="container mx-auto px-4">
				<div className="mx-auto max-w-4xl rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent p-8 text-center sm:p-14">
					<h2 className={`${SECTION_TITLE.className} mb-4`}>
						{t("title")}
					</h2>
					<p className="mx-auto mb-8 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
						{t("description")}
					</p>
					<Button
						size="lg"
						className="mx-auto h-12 rounded-lg bg-blue-500 px-8 text-sm font-medium text-white shadow-lg shadow-blue-500/20 hover:bg-blue-600"
						onClick={() =>
							document
								.getElementById("image-effect-workbench")
								?.scrollIntoView({
									behavior: "smooth",
									block: "start",
								})
						}
					>
						{form("create")}
						<ChevronRight className="ml-1 size-4" />
					</Button>
				</div>
			</div>
		</section>
	);
}
